var React = require('react');

function NavigationMenuVertical (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")),React.createElement("circle",{"className":"a","cx":"11.987","cy":"20.628","r":"2.625","key":1}),React.createElement("circle",{"className":"a","cx":"11.987","cy":"3.378","r":"2.625","key":2}),React.createElement("circle",{"className":"a","cx":"11.987","cy":"12.003","r":"2.625","key":3})]);
}

NavigationMenuVertical.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavigationMenuVertical;

NavigationMenuVertical.default = NavigationMenuVertical;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svgs/navigation-menu-vertical.svg
// module id = 1077
// module chunks = 0